import { Tooltip } from '@/components/Tooltip';
import { getEvmThreshold } from '@/sections/customerManagement/utils/evmThresholds';

export function EvmScoreCell({ score }: { score: number }) {
  const { label, dotClassName } = getEvmThreshold(score);
  return (
    <Tooltip title={`${label} (${score.toFixed(1)}/10)`}>
      <span className="flex items-center gap-1.5">
        <span className={`size-2.5 shrink-0 rounded-full ${dotClassName}`} />
        <span className="text-sm">{score.toFixed(1)}</span>
      </span>
    </Tooltip>
  );
}

export function ScoreCell({ score }: { score: number }) {
  return <span className="text-sm">{score.toFixed(1)}</span>;
}
